import React, { useState } from "react"
import PropTypes from "prop-types"
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"

//i18n
import { withTranslation } from "react-i18next"
// Redux
import { connect } from "react-redux"
import { Link } from "react-router-dom"
import withRouter from "components/Common/withRouter"

// users
import user1 from "../../../assets/images/avatar.png"
import { useAuth } from "hooks/authHook"
import { getProfileImageUrl } from "components/Common/ProfileImageUploader"

const ProfileMenu = props => {
  const [menu, setMenu] = useState(false)
  const [isLoggingOut, setIsLoggingOut] = useState(false)

  const { logout, user, isImpersonating, stopImpersonating } = useAuth()

  const displayName = user?.name || user?.username || ""
  const avatarSrc = getProfileImageUrl(user) || user1

  const closeMenu = () => setMenu(false)

  const handleLogout = async () => {
    if (isLoggingOut) return

    setIsLoggingOut(true)
    closeMenu()
    try {
      if (isImpersonating) {
        await stopImpersonating()
      } else {
        await logout()
      }
    } catch (error) {
    } finally {
      setIsLoggingOut(false)
    }
  }

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item "
          id="page-header-user-dropdown"
          tag="button"
        >
          <img
            className="rounded-circle header-profile-user"
            src={avatarSrc}
            alt="Header Avatar"
          />
          <span className="d-none d-xl-inline-block ms-2 me-1">
            {displayName}
          </span>
          <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          <DropdownItem tag={Link} to="/profile" onClick={closeMenu}>
            <i className="bx bx-user font-size-16 align-middle me-1" />
            {props.t("Profile")}
          </DropdownItem>
          <div className="dropdown-divider" />
          <button
            type="button"
            onClick={handleLogout}
            className="dropdown-item text-start"
            disabled={isLoggingOut}
            style={{ background: "transparent", border: 0, width: "100%" }}
          >
            <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
            <span>
              {isLoggingOut
                ? "Logging out..."
                : isImpersonating
                ? "Stop Impersonating"
                : props.t("Logout")}
            </span>
          </button>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  )
}

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any,
}

const mapStatetoProps = state => {
  const { error, success } = state.Profile
  return { error, success }
}

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
)
